import { useTar } from '@/modules'
import { Logo } from '../Misc/Logo'

export const AboutPage = () => {
    const { t } = useTar()
    return (
        <div className="flex flex-1 w-full justify-center">
            <div className="flex-1 max-w-6xl space-y-12 mt-8 mb-16">
                {/* Header Section */}
                <div className="text-center space-y-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-foreground">
                        {t('common.about')} <Logo />
                    </h1>
                    <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
                        {t('about.subtitle')}
                    </p>
                </div>

                {/* Mission Section */}
                <div className="bg-card rounded-lg shadow-sm border border-border p-8 space-y-6">
                    <div className="space-y-4">
                        <h2 className="text-3xl font-bold text-foreground">{t('about.ourMission')}</h2>
                        <p className="text-lg text-muted-foreground leading-relaxed">
                            {t('about.missionP1')}
                        </p>
                        <p className="text-lg text-muted-foreground leading-relaxed">
                            <strong className="text-foreground">XP Lab</strong> {t('about.missionP2Suffix')}
                        </p>
                    </div>
                </div>

                {/* What We Offer Section */}
                <div className="space-y-6">
                    <h2 className="text-3xl font-bold text-foreground text-center">{t('about.whatWeOffer')}</h2>
                    <div className="grid md:grid-cols-3 gap-6">
                        <div className="bg-card rounded-lg shadow-sm border border-border p-6 space-y-3">
                            <div className="text-4xl">🎯</div>
                            <h3 className="text-xl font-semibold text-foreground">{t('about.realWorldChallengesTitle')}</h3>
                            <p className="text-muted-foreground">
                                {t('about.realWorldChallengesDescription')}
                            </p>
                        </div>
                        <div className="bg-card rounded-lg shadow-sm border border-border p-6 space-y-3">
                            <div className="text-4xl">💬</div>
                            <h3 className="text-xl font-semibold text-foreground">{t('about.actionableFeedbackTitle')}</h3>
                            <p className="text-muted-foreground">
                                {t('about.actionableFeedbackDescription')}
                            </p>
                        </div>
                        <div className="bg-card rounded-lg shadow-sm border border-border p-6 space-y-3">
                            <div className="text-4xl">📈</div>
                            <h3 className="text-xl font-semibold text-foreground">{t('about.trackProgressTitle')}</h3>
                            <p className="text-muted-foreground">
                                {t('about.trackProgressDescription')}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Philosophy Section */}
                <div className="bg-card rounded-lg shadow-sm border border-border p-8 space-y-6">
                    <div className="space-y-4">
                        <h2 className="text-3xl font-bold text-foreground">{t('about.ourPhilosophy')}</h2>
                        <div className="space-y-4">
                            <div className="flex gap-4">
                                <div className="text-2xl mt-1">🧠</div>
                                <div>
                                    <h3 className="text-lg font-semibold text-foreground mb-2">{t('about.learningByDoingTitle')}</h3>
                                    <p className="text-muted-foreground">
                                        {t('about.learningByDoingDescription')}
                                    </p>
                                </div>
                            </div>
                            <div className="flex gap-4">
                                <div className="text-2xl mt-1">⏳</div>
                                <div>
                                    <h3 className="text-lg font-semibold text-foreground mb-2">{t('about.deepLearningTitle')}</h3>
                                    <p className="text-muted-foreground">
                                        {t('about.deepLearningDescription')}
                                    </p>
                                </div>
                            </div>
                            <div className="flex gap-4">
                                <div className="text-2xl mt-1">🤝</div>
                                <div>
                                    <h3 className="text-lg font-semibold text-foreground mb-2">{t('about.radicalCandorTitle')}</h3>
                                    <p className="text-muted-foreground">
                                        {t('about.radicalCandorDescription')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Team Section */}
                <div className="space-y-6">
                    <h2 className="text-3xl font-bold text-foreground text-center">{t('about.theTeam')}</h2>
                    <div className="bg-card rounded-lg shadow-sm border border-border p-8">
                        <p className="text-lg text-muted-foreground text-center leading-relaxed max-w-3xl mx-auto">
                            {t('about.teamDescription')}
                        </p>
                    </div>
                </div>

                {/* Contact Section */}
                <div className="bg-gradient-to-r from-emerald-600/10 via-green-500/10 to-emerald-600/10 rounded-lg p-8 text-center space-y-4">
                    <h2 className="text-2xl font-bold text-foreground">{t('about.getInTouch')}</h2>
                    <p className="text-muted-foreground">
                        {t('about.getInTouchDescription')}
                    </p>
                    <div className="pt-2">
                        <a
                            href="mailto:tal@xp-lab.com"
                            className="inline-flex items-center gap-2 px-6 py-3 bg-accent text-white rounded-lg font-medium
                       hover:bg-accent/90 transition-colors duration-200"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            {t('about.contactUs')}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
